import React, { Component } from 'react'
import { fetchPollList } from 'src/actions/timepoll'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './time-poll-panel.scss'
import TimePollCard from './TimePollCard/TimePollCard'
import moment from 'moment'
import LoadingComponent from 'components/common/LoadingComponent/LoadingComponent'
import { userIdSelector } from 'src/selectors'
import EmptyPanel from '../EmptyPanel/EmptyPanel'

class TimePollPanel extends Component {
  state = {
    pollList: [],
    loading: true
  }

  handleSortPolls = polls => {
    const pollsDetailsStatusSort = polls.sort((a, b) => {
      if (a.status === 'active' && (b.status === 'closed' || !b.status)) {
        return -1
      }
      if ((a.status === 'closed' || !a.status) && b.status === 'active') {
        return 1
      }
      return 0
    })

    let result = pollsDetailsStatusSort.sort((a, b) => {
      if (a.status === 'active' && b.status === 'active') {
        if (moment(a.updated_at).isBefore(b.updated_at)) {
          return -1
        }
        return 1
      }
      if ((a.status === 'closed' || !a.status) && (b.status === 'closed' || !b.status)) {
        if (moment(a.updated_at).isBefore(b.updated_at)) {
          return 1
        }
        return -1
      }
      return 0
    })

    if (this.props.inHomePage && result.length > 6) {
      result = result.slice(0, 6)
    }

    this.setState({
      pollList: result,
      loading: false
    })
  }

  componentDidUpdate(prevProps) {
    const { userId } = this.props
    const { pollList } = this.state

    if (prevProps.userId !== userId && userId && pollList.length === 0 && this._isMounted) {
      this.onLoadPollList()
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.onLoadPollList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  onLoadPollList = () => {
    const { onFetchPollList } = this.props
    onFetchPollList({
      status: 'all',
      pollType: 'time',
      onSuccessCallback: data => {
        if (data.data.poll_list?.result && this._isMounted) {
          this.handleSortPolls(data.data.poll_list.result)
        }
      }
    })
  }

  render() {
    const { pollList, loading } = this.state

    if (loading) {
      return (
        <div style={{ width: '100%', height: '100%' }}>
          <LoadingComponent type="partial" loading light />
        </div>
      )
    }

    if (pollList.length === 0) {
      return <EmptyPanel type="tp" />
    }

    return (
      <div className={styles['time-poll-panel-container']}>
        {pollList.map(poll => (
          <TimePollCard key={poll.id} poll={poll} userId={this.props.userId} />
        ))}
      </div>
    )
  }
}

TimePollPanel.propTypes = {
  userId: PropTypes.string,
  onFetchPollList: PropTypes.func,
  inHomePage: PropTypes.bool
}

function mapDispatchToProps(dispatch) {
  return {
    onFetchPollList: params => dispatch(fetchPollList(params))
  }
}

function mapStateToProps(state) {
  return {
    userId: userIdSelector(state)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimePollPanel)
